import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import PortalLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { AuthProvider, useAuth } from "contexts/AuthContext";
import { PlatformStatusProvider } from "contexts/PlatformStatusContext";

function RequireAuth({ children }) {
  const { status, user } = useAuth();
  if (status === "loading") {
    return <div className="flex h-screen w-screen items-center justify-center text-sm text-gray-500">Loading…</div>;
  }
  if (status === "signed-out") {
    return <Navigate to="/auth/sign-in" replace />;
  }
  if (user?.mustChangePassword) {
    return <Navigate to="/auth/set-password" replace />;
  }
  return children;
}

const App = () => {
  return (
    <AuthProvider>
      <PlatformStatusProvider>
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />
        <Route
          path="portal/*"
          element={
            <RequireAuth>
              <PortalLayout />
            </RequireAuth>
          }
        />
        <Route path="/" element={<Navigate to="/portal" replace />} />
      </Routes>
      </PlatformStatusProvider>
    </AuthProvider>
  );
};

export default App;
